import { Routes } from '@angular/router';
import { ForgotPasswordComponent } from './pages/users/forgot-password/forgot-password.component';
import { HomeComponent } from './pages/users/home/home.component';
import { LoginComponent } from './pages/users/login/login.component';
import { RegisterComponent } from './pages/users/register/register.component';
import { ResetPasswordComponent } from './pages/users/reset-password/reset-password.component';

export const routes: Routes = [
  { path: 'auth', component: HomeComponent },
  { path: '', redirectTo: '/auth', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
];
